export default __webpack_public_path__ + "static/1-b92c4caff484947dde99f04f40a44e06.jpeg";